import { createContext } from 'react';
import { NotificationContextData } from './interfaces/notification-context-props.interface';

const NotificationContext = createContext<NotificationContextData>(
    {} as NotificationContextData,
);

export default NotificationContext;
